var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6068 6.69C19.5814 6.47079 18.6539 5.94144 17.9572 5.17789C17.2606 4.41435 16.8306 3.45587 16.7291 2.44V2H13.1805V15.67C13.1812 16.2766 12.9856 16.868 12.6214 17.3604C12.2572 17.8529 11.7428 18.2215 11.1512 18.414C10.5595 18.6065 9.9206 18.6131 9.32488 18.4329C8.72915 18.2527 8.20684 17.8948 7.83193 17.41C7.49605 16.9808 7.29038 16.4689 7.23817 15.932C7.18596 15.3951 7.2893 14.8548 7.53651 14.372C7.78371 13.8892 8.16491 13.4834 8.63701 13.2003C9.1091 12.9172 9.65325 12.7681 10.2079 12.77C10.5147 12.7683 10.8199 12.8121 11.1131 12.9V9.4C10.7719 9.35893 10.4282 9.34222 10.0845 9.35C8.81865 9.38288 7.59014 9.77393 6.54939 10.4753C5.50865 11.1766 4.70085 12.1578 4.22492 13.2986C3.74899 14.4395 3.62558 15.6905 3.8698 16.8986C4.11402 18.1066 4.71527 19.2191 5.59994 20.1C6.50661 20.9962 7.66684 21.6101 8.93322 21.8638C10.1996 22.1175 11.5149 21.9994 12.7121 21.5246C13.9093 21.0498 14.9343 20.2397 15.6569 19.1973C16.3795 18.1548 16.767 16.9271 16.7702 15.67V8.67C18.2014 9.66395 19.9176 10.1956 21.6765 10.19V6.79C21.331 6.79139 20.9863 6.75787 20.6479 6.69H20.6068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.cb5a7969dc6a73f41d66c83d951f673f.svg";
export { ForwardRef as ReactComponent };